import { render, staticRenderFns } from "./contact-us-button-compact.vue?vue&type=template&id=4bcd31c4&scoped=true&"
import script from "./contact-us-button-compact.vue?vue&type=script&lang=js&"
export * from "./contact-us-button-compact.vue?vue&type=script&lang=js&"
import style0 from "./contact-us-button-compact.vue?vue&type=style&index=0&id=4bcd31c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcd31c4",
  null
  
)

export default component.exports